import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpPoint } from '../sylndr-help.types';
import { Dispatch, SetStateAction } from 'react';
import Modal from '@/components/shared/ModalV1/Modal.component';
import { HelpSectionDesc } from './help-detailed-item';
import { StaticImageData } from 'next/image';
import { HelpSectionSteps } from './help-steps';

export const SylndrHelpModal = ({
    section,
    lang,
    openModal,
    setOpenModal,
    gradientColor,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
    openModal: boolean;
    gradientColor: string;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
}) => {
    return (
        <Modal
            open={openModal}
            setOpen={setOpenModal}
            className="!rounded-xl w-[50%]"
            header={<div />}
            style={{
                background: `linear-gradient(180deg, ${gradientColor} 0%, rgba(245, 254, 255, 0) 32%), #FFF`,
            }}
        >
            <div
                className={`h-full w-full flex flex-col relative 
        `}
            >
                <div className="px-6 pt-2">
                    <div className="flex justify-between gap-x-3 pb-6">
                        <HelpSectionDesc
                            image={section.icon as StaticImageData}
                            title={section.title[lang]}
                            desc={section.desc[lang]}
                        />
                        {/* <VideoEntryPoint
                                t={t}
                                gradient="from-emerald-600/25 from-60% to-emerald-600/10"
                                image={SylndrHelpVideoThumbnail}
                                title={t(
                                    `CarProfile.SylndrHelp.VideoEntryPoint.${[
                                        section.key,
                                    ]}.title`
                                )}
                                subTitle={t(
                                    `CarProfile.SylndrHelp.VideoEntryPoint.${[
                                        section.key,
                                    ]}.subTitle`
                                )}
                                passedVidURL={section.videoURL.DESKTOP}
                            /> */}
                    </div>
                    <div>
                        <HelpSectionSteps section={section} lang={lang} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
